// src/config/store.tsx

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

// This is the simplest possible store configuration that will work.
const store = configureStore({
  reducer: rootReducer,
  // Middleware (like redux-thunk) is automatically included.
  // We have temporarily removed the logger to solve the type errors.
});

// These types are still needed for your slices.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;